import React from 'react';

function Search() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#3AB2EE"
        d="M9.462 10.873a5.99 5.99 0 111.41-1.411l4.81 4.808a1 1 0 01-1.087 1.642.997.997 0 01-.324-.231l-4.81-4.808zm.523-4.883a3.994 3.994 0 10-7.987 0 3.994 3.994 0 007.987 0z"
      ></path>
    </svg>
  );
}

export default Search;
